import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const { instance } = useMsal();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      // Automatically trigger redirect login when not authenticated
      instance.loginRedirect(loginRequest).catch((error) => {
        console.error('Auto-login redirect failed:', error);
      });
    }
  }, [isAuthenticated, loading, instance]);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          bgcolor: 'background.default'
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Redirecting to authentication...
        </Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Show loading while redirect is in progress
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          bgcolor: 'background.default'
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Redirecting to Microsoft authentication...
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;